import {
  createRouter,
  createWebHistory
} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import RecordView from '../views/RecordView.vue'
import Errors from '../views/404View.vue'
import SiteClosedView from '../views/SiteClosedView.vue'
import { http3 } from '@/utils/http'

const routes = [{
    path: '/home',
    name: 'Home',
    component: HomeView,
    meta: { requiresSiteAuthorization: true }
  },
  {
    path: '/record',
    name: 'record',
    component: RecordView,
    meta: { requiresSiteAuthorization: true }
  },
  {
    path: '/homes',
    name: 'homes',
    component: SiteClosedView
  },
  {
    path: "/",
    redirect: to => ({ name: "Home", query: to.query }),
  },
  {
    path: "/:any(.*)",
    name:"notFound",
    component:Errors,
  }
]

// path: "/:any(.*)",
// name: "notFound",
// meta: { intercept: true },
// component: () => import("@/views/errors/404.vue")

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  if (!to.matched.some(record => record.meta.requiresSiteAuthorization)) {
    return true
  }

  try {
    const response = await http3.get('/v1/user/getUserNum', {
      params: { auth: to.query.auth }
    })

    if (String(response.data?.data?.is_auth) === '18') {
      return true
    }
  } catch (error) {
    console.error('站点鉴权失败:', error)
  }

  return { name: 'homes', query: to.query, replace: true }
})

export default router
